export const legacyAliases = [
  { path: '/v2', redirect: '/v2/operate' },
  { path: '/operate', redirect: '/v2/operate' },
  { path: '/analyze', redirect: '/v2/analyze' },
  { path: '/tools', redirect: '/v2/tools' },
  { path: '/manage', redirect: '/v2/manage' },
  { path: '/admin', redirect: '/v2/admin' },
  { path: '/settings/manage', redirect: '/v2/manage' },
  { path: '/settings/admin', redirect: '/v2/admin' },
  { path: '/applications', redirect: '/v2/tools' },
  {
    path: '/dashboard/:dataID/portal',
    redirect: (to) => ({
      path: `/v2/analyze/portal/${to.params.dataID}`,
      query: to.query,
      hash: to.hash,
    }),
  },
  { path: '/v2/tools/applications', redirect: '/applications' },
  {
    path: '/v2/analyze/portal/:dataID',
    redirect: (to) => ({
      path: `/dashboard/${to.params.dataID}/portal`,
      query: to.query,
      hash: to.hash,
    }),
  },
];
